var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{class:_vm.booking.checked ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger',attrs:{"title":_vm.booking.checked ? 'Reserva chequeada' : 'Reserva sin chequear'}})])}
var staticRenderFns = []

export { render, staticRenderFns }